export default __webpack_public_path__ + "static/media/shape2.80eec00c.svg";